<template>
  <div class="vg_wrapper">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="单据信息" name="first" :key="'first'">
        <childTab1 />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import MqcdAddMain from '@/views/StockManagement/MqcdManage/TabChild/MqcdAddMain';
export default {
  name: 'MqcdAdd',
  components: {
    childTab1: MqcdAddMain
  },
  data() {
    return {
      activeName: 'first'
    };
  }
};
</script>

<style scoped></style>
